angular.module('bmsApp.trugreen.bulkPriceUpdate', [
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider
				.state('main.trugreen.bulkPriceUpdate', {
					url: '^/trugreen/bulk-price-update',
					views: {
						'main@main': {
							templateUrl: 'ng/trugreen/bulk-price-update/templates/TGBulkPriceUpdate.html',
							controller: 'TGBulkPriceUpdateCtrl'
						},
					},
					ncyBreadcrumb: {label: 'Bulk Price Update'}
				})
			;
		}]);
